import React, { createContext, useContext, useState } from 'react';

interface TourContextType {
  isTourActive: boolean;
  startTour: () => void;
  endTour: () => void;
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export function TourProvider({ children }: { children: React.ReactNode }) {
  const [isTourActive, setIsTourActive] = useState(false);

  const startTour = () => {
    localStorage.removeItem('guidedTourSeen');
    setIsTourActive(true);
  };

  const endTour = () => {
    setIsTourActive(false);
    localStorage.setItem('guidedTourSeen', 'true');
  };

  return (
    <TourContext.Provider value={{ isTourActive, startTour, endTour }}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  const context = useContext(TourContext);
  if (context === undefined) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
} 